module.exports = __webpack_public_path__ + "assets/img/sailing-version-advantagefeature-bg.a562e118.png";